import type { FaireProductEntity } from "../../entity_types/product";

export const p_nsp8d98hve: FaireProductEntity = {
  token: "p_nsp8d98hve",
  type: "product",
  name: "Stacked Stripes Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl:
    "https://cdn.faire.com/fastly/edc28dfdcf6d3098bbc3feea612c34ba34abd0fa697fdd96f3649cb9db023ab2.jpeg",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    'Meet the towel that put us on the map! Geometry\'s bestselling Tea Towel is a necessity in every kitchen!\n\n• 18" x 30"\n• Made from recycled polyester\n• Weight: 320 g\n• Single-sided print\n• Hang loop\n• Waffle weave construction\n• Quick-drying\n• Superior Cleaning\n• Next-level absorbency',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:43.623Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
